/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import loosePentagonUrl from '../../../assets/gems/loose_pentagon.svg?inline';
export function LoosePentagon({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: loosePentagonUrl,
        alt: "LoosePentagonImage"
    });
}
